import { render, staticRenderFns } from "./ModulesList.vue?vue&type=template&id=3ae0d9a8"
import script from "./ModulesList.vue?vue&type=script&lang=ts"
export * from "./ModulesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports